import * as React from 'react';

import './index.less';

const icon1 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/loading.gif';
const icon2 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/not_data.png';

export default function Spinner(props: any) {
  const { loading, dataVis } = props;
  return (
    <div className='global-loading'>
      <img src={loading && !dataVis ? icon1 : icon2} alt='' />
      <span>{loading && !dataVis ? 'loading...' : '暂无数据！'}</span>
    </div>
  );
}
